import { useProgrammeWorkoutsAvailability } from './use-programme-workouts'

export const useProgrammeWorkoutsLockStatus = (
  programmeId: string,
): {
  areProgrammeWorkoutsInWeekLocked: (onWeek: number) => boolean
  isWeekLocked: (onWeek: number) => boolean
} => {
  const { data: programmeWorkoutsAvailability = [] } = useProgrammeWorkoutsAvailability(programmeId)

  const areProgrammeWorkoutsInWeekLocked = (onWeek: number): boolean => {
    const onWeekAvailability = programmeWorkoutsAvailability.find((pwa) => pwa.onWeek === onWeek)
    return onWeekAvailability?.areProgrammeWorkoutsInWeekLocked ?? false
  }

  const isWeekLocked = (onWeek: number): boolean => {
    const onWeekAvailability = programmeWorkoutsAvailability.find((pwa) => pwa.onWeek === onWeek)
    return onWeekAvailability?.isWeekLocked ?? false
  }

  return {
    areProgrammeWorkoutsInWeekLocked,
    isWeekLocked,
  }
}
